import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TreatmentPlanningDataModel } from '../../treatment-planning/models/treatment-planning-data.model';
import { TreatmentPlanningService } from '../../treatment-planning/treatment-planning.service';
import { InsuranceService } from '../../insurance/insurance.service';
import { TdoClientConfigurationModel } from 'src/app/models/clients/tdo-client-configuration.model';
import { Globals } from 'src/app/globals';
import { PatientInsuranceDataModel } from 'src/app/models/patient/patient-insurance-data.model';
import { ToastrService } from 'ngx-toastr';
import { ToothConfigurationModel } from 'src/app/models/teeth/tooth-configuration.model';
import { ToothService } from 'src/app/services/tooth.service';
import { TreatmentPlanningProcedurePseudoModel } from '../../treatment-planning/models/treatment-planning-procedure-pseudo.model';
import { ARService } from '../../ar/ar.service';
import { Constants, customFormTreatmentPlanning } from 'src/app/constants';
import { CreateTransactionItemModel } from 'src/app/models/accountsReceivable/create-transaction-item.model';
import { TREATMENT_PLAN_STATUS } from 'src/app/models/constants/treatment-plan-status.model';
import { FeeItemCategoryIdEnum } from 'src/app/models/enum/fee-item-category-id.enum';
import { CaseFormsService } from '../case-forms.service';
import { DataPatientCaseWorkItemModel } from 'src/app/models/accountsReceivable/data-patient-case-work-item.model';

@Component({
  selector: 'app-case-bill-functionality',
  templateUrl: './case-bill-functionality.component.html',
  styleUrls: ['./case-bill-functionality.component.scss']
})
export class CaseBillFunctionalityComponent implements OnInit {

  caseInformation: string;
  isLoading: boolean = false;
  tabSelected: number = 0;
  selectedCaseWorkItemForm: string;

  selectedParentTreatmentPlan: TreatmentPlanningDataModel;
  tabPanelTreatmentPlanSelectedIndex: number = 0;
  currentTreatmentPlans: TreatmentPlanningDataModel[] = [];
  cfgTDOClient: TdoClientConfigurationModel;
  insuranceModels: PatientInsuranceDataModel[];

  listOfParentTreatmentPlans: TreatmentPlanningDataModel[] = [];
  teeth: ToothConfigurationModel[];
  procedurePayloads: CreateTransactionItemModel[] = [];
  selectedBillableItems: any[] = [];
  selectedTreatmentPlan: TreatmentPlanningDataModel;
  caseWorkItems: DataPatientCaseWorkItemModel[];
  
  
  constructor(
    public dialogRef: MatDialogRef<CaseBillFunctionalityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private treatmentPlanningService: TreatmentPlanningService,
    private insuranceService: InsuranceService,
    public globals: Globals,
    private toastr: ToastrService,
    private toothService: ToothService,
    private arService: ARService,
    private caseService: CaseFormsService,
  ){

    if (!this.toothService.allTeeth || this.toothService.allTeeth.length === 0) {
      // TODO: Things like this will need to be updated once we have a way to check settings like geoloc.
      this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe((teeth) => {
        this.teeth = teeth;
      });
    } else {
      this.teeth = this.toothService.allTeeth;
    }
   
  }
  async ngOnInit() {
    try {
      if(this.data.PatientCaseId == 'null'){
        this.displayMessage('Error', 'No case selected'); 
        this.isLoading = false;
        return;
      }
      this.isLoading = true;
      this.caseInformation =  localStorage.getItem('SelectedCaseDescription')

      this.caseWorkItems = await this.caseService.getCaseWorkItemsByPatientCaseID(this.data.PatientCaseId).toPromise();
      console.log('caseWorkItems:', this.caseWorkItems);
      this.selectedCaseWorkItemForm = this.caseWorkItems
        .find(p => p.dataPatientCaseItemForms.some(p => p.enumCustomFormID === customFormTreatmentPlanning))
        ?.dataPatientCaseItemForms.find(p => p.enumCustomFormID === customFormTreatmentPlanning)?.CaseWorkItemFormsId;

      this.insuranceModels = await this.insuranceService.getPatientInsuranceByPatientId(this.globals.currentPatientId).toPromise();
     
      //get BillableItmes
      this.selectedBillableItems = await this.arService.getBillableItems(this.data.PatientCaseId).toPromise();
      await this.loadTreatmentPlanList();

    } catch (err) {
      this.isLoading = false;
      this.displayMessage('Error', 'Error initializing information');
    }
  }

    async loadTreatmentPlanList() 
    {
      this.isLoading = true;
      this.listOfParentTreatmentPlans = await this.treatmentPlanningService.getTreatmentPlanList(this.globals.currentPatientId).toPromise(); 
      this.selectedParentTreatmentPlan = this.listOfParentTreatmentPlans.find(x => x.CaseWorkItemFormsId ===  this.selectedCaseWorkItemForm )//this.listOfParentTreatmentPlans.at(0);
      this.setParentTreatmentPlan(this.selectedParentTreatmentPlan);
    }


  saveBill() {
    if(this.procedurePayloads.length == 0){
      this.displayMessage('warning', 'Pleses select at least one item to bill'); 
      return;
    }
    const transactionItemID = Constants.emptyGuid; 
    this.arService.createTransactionItems(this.procedurePayloads, transactionItemID).toPromise();
    this.displayMessage('success', 'Bill saved successfully');
    this.dialogRef.close(true);

    }

  onItemCheckBox(event, item: any, index: number) {
    item.isSelected = event.checked;
    if (event.checked) 
    {
      const payload = new CreateTransactionItemModel();
      payload.PatientId = this.globals.currentPatientId;
      payload.CaseProcedureId = item.CaseProcedureId;
      payload.PatientInsuranceID = this.insuranceModels[0].PatientInsuranceID;
      payload.ProviderDoctorID = index === 1 ? item.ProviderDoctorID : this.caseWorkItems.find(p => p.dataPatientCaseItemForms.find(p => p.CaseWorkItemFormsId === this.selectedTreatmentPlan.CaseWorkItemFormsId)).ProviderDoctorID;
      payload.CaseWorkItemID = index === 1 ? item.CaseWorkItemId : this.caseWorkItems.find(p => p.dataPatientCaseItemForms.find(p => p.CaseWorkItemFormsId === this.selectedTreatmentPlan.CaseWorkItemFormsId)).CaseWorkItemId;
      payload.LOCID = index === 1 ? item.LOCID : this.caseWorkItems.find(p => p.dataPatientCaseItemForms.find(p => p.CaseWorkItemFormsId === this.selectedTreatmentPlan.CaseWorkItemFormsId)).LOCID;
      payload.TransactionDate = new Date();
      payload.Code = item.Code;
      payload.CodeDescription = item.ProcedureName;
      payload.enumFeeItemCategoryId = FeeItemCategoryIdEnum.Other;
      payload.ToothID = item.ToothID;
      this.procedurePayloads.push(payload);
    } 
    else {
      this.procedurePayloads = this.procedurePayloads.filter(p => p.Code !== item.Code && p.ToothID !== item.ToothID && p.CaseProcedureId !== item.CaseProcedureId);
    }
  }


  displayMessage(type, message) {
    if (type.toLowerCase() === "error")
      this.toastr.error(message, null, { timeOut: 7000 });
    else if (type.toLowerCase() === "warning")
      this.toastr.warning(message, null, { timeOut: 3000 });
    else
      this.toastr.success(message, null, { timeOut: 3000 });
  }

  cancel(payload) {
    this.dialogRef.close(payload);
  }

  setParentTreatmentPlan(model: TreatmentPlanningDataModel) {
    if (!model){
      console.log('setParentTreatmentPlan: model is null');
      this.isLoading = false;
      return;
    }
    this.selectedParentTreatmentPlan = model;
    this.tabPanelTreatmentPlanSelectedIndex = 0;
    this.isLoading = true;

    this.treatmentPlanningService.getTreatmentPlan(this.selectedParentTreatmentPlan.TreatmentPlanningID).subscribe((plans) => {
      this.currentTreatmentPlans = plans.filter(p => p.enumTreatmentPlanStatusID.toLocaleUpperCase() === TREATMENT_PLAN_STATUS.AcceptedByPatient);
      this.setupPlanTeeth();

      if (this.currentTreatmentPlans && this.currentTreatmentPlans.length > 0) {
        this.selectedTreatmentPlan = this.currentTreatmentPlans[0];
        this.selectedTreatmentPlan.Procedures = this.currentTreatmentPlans.map(p => p.Procedures).reduce((a, b) => a.concat(b));
      } else {
        this.isLoading = false;
      }
      // remove repetitive procedure from Sum up items
      this.selectedBillableItems = this.selectedBillableItems.filter(p => !this.selectedTreatmentPlan.Procedures.find(p2 => p2.Code === p.Code && p2.ToothID === p.ToothID));
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
      this.displayMessage('Error', 'Something went wrong');
    });
  }


  setupPlanTeeth() {
    for (const plan of this.currentTreatmentPlans) {
      for (const proc of plan.Procedures) {
        proc.toothModel = this.teeth.find(p => p.ToothId === proc.ToothID);
      }
    }
  }

  getOriginalDoctorsFee(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.Fee != null) {
      return procedure.Fee.toString();
    } else {
      return '0.00';
    }
  }

  getFeeAdjusted(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceAdjusted !== null && procedure.PriceAdjusted !== 0) {
      return Number(procedure.PriceAdjusted).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  getInsuranceEstimate(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceTotalDueByInsurance != null && procedure.PriceTotalDueByInsurance !== 0) {
      return Number(procedure.PriceTotalDueByInsurance).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  getDeductible(procedure: TreatmentPlanningProcedurePseudoModel): string {
    // Currently deductible isn't being brought across
    if (procedure.Deductible != null) {
      return Number(procedure.Deductible).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  getPaymentEstimate(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceDueByPatient !== null && procedure.PriceDueByPatient !== 0) {
      return Number(procedure.PriceDueByPatient).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

}
